/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import { useNavigate, Link } from 'react-router-dom';
import Modal from 'react-modal';

const Step3 = ({ onBack, onNext, role,token, formData, setFormData }) => {
    const [showType, setShowType] = useState(formData.showType ?? 0);
    const [canadianAreaCodes, setCanadianAreaCodes] = useState(new Set());
    const isCanadianNumber = (item) => canadianAreaCodes.has(String(item.telephoneNumber).substring(0, 3));
    const [featureType, setFeatureType] = useState(0);
    const [dipFeatureType, setDipFeatureType] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [assignedCname, setAssignedCname] = useState(formData.assignedCname ?? {});
    const [assignedCas, setAssignedCas] = useState(formData.assignedCas ?? {});
    const [selectAll, setSelectAll] = useState(false);
    const [ciaEnableSwitch, setCiaEnableSwitch] = useState(false);
    const [ciaOrderSwitch, setCiaOrderSwitch] = useState(false);
    const [ciaLabelDisplay, setCiaLabelDisplay] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => {
        if(formData.showType == undefined){
            setFormData({ ...formData, showType: 0 });
        }
    }, [formData.showType]);
    useEffect(() => {
        if(formData.selectedCompany){
            getCustomerTNSAccess();
        }
    }, [formData.selectedCompany]);

    useEffect(() => {
        axios.get(`${baseUrl}/canadian-area-codes`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setCanadianAreaCodes(new Set(res.data.data));
        }).catch(err => console.log('Failed to load Canadian area codes', err));
    }, []);
    useEffect(() => {
        if(ciaOrderSwitch){
            setShowType(2);

            const tnList = formData.reserveNumberList.filter(item => formData.methodType == 0).map(item => item.telephoneNumber)
            const updatedAssignedCas = { ...assignedCas };
            tnList.forEach((telephoneNumber) => {
            updatedAssignedCas[telephoneNumber] = "enable";
        });
        // console.log(updatedAssignedCname);
        // console.log(formData.tnNumberRouteList);

        const updatedtnNumberList = formData.tnNumberRouteList.map((obj) => {
            const telephoneNumber = obj.telephoneNumber;
            const casValue = updatedAssignedCas[telephoneNumber];

            if (casValue) {
              return {
                ...obj,
                cia_value: casValue ,
              };
            } else {
              return obj;
            }
        });    
        // console.log(updatedAssignedCas);
        // console.log(updatedtnNumberList);
        setFormData({ ...formData, tnNumberRouteList: updatedtnNumberList, assignedCas :updatedAssignedCas });
        setAssignedCas(updatedAssignedCas);
        }
    }, [ciaOrderSwitch]);

    const getCustomerTNSAccess = async () => {
        try {
            // setApiCallCount((prevCount) => prevCount + 1);
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${formData.selectedCompany}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            // if(response.data.cia_new_order_switch == 1 || response.data.cia_new_order_switch == 0){
                if((role > 2 && response.data.cia_account_type == 1) || (role <= 2)){
                    if(response.data.cia_enable_switch === 1){
                        setCiaEnableSwitch(true);
                    }else{
                        setCiaEnableSwitch(false);
                    }
                    // if(response.data.cia_new_number_switch === 1){
                    //     setCiaOrderSwitch(true);
                    // }else{
                    //     setCiaOrderSwitch(false);
                    // }
                    if(response.data.cia_new_order_switch === 1 && response.data.cia_new_number_switch === 0){
                        setCiaLabelDisplay(true);
                    }
                }else{
                    setCiaEnableSwitch(false);
                    // setCiaOrderSwitch(false);
                }
                if(response.data.cia_new_number_switch == 1){
                    setCiaOrderSwitch(true);
                }else{
                    setCiaOrderSwitch(false);
                }
                
            
           

        } catch (error) {
            // setLoading(false);
            
           console.log(error);
            
        }
    }
    const handleRadioChange = (e) => {
        setShowType(Number(e.target.value));
        setFormData({ ...formData, showType: Number(e.target.value) });
        if(Number(e.target.value) == 0){
            const modifiedArray = formData.tnNumberRouteList.map(obj => {
                // Destructure the objec{ciaOrderSwitch}3t and exclude 'callerid' key
                const { callerId, ...rest } = obj;
                if(!ciaOrderSwitch){
                    const { cia_value, ...restWithoutCiaValue } = rest;
                    return restWithoutCiaValue;
                }
                
                return rest; // Return the modified object without 'callerid'
            });
            const obj = { ...formData, tnNumberRouteList: modifiedArray, showType: Number(e.target.value), assignedCname : {} };
            if(!ciaOrderSwitch){
                obj.assignedCas = {};
                setAssignedCas({});
            }
            setFormData(obj);
            setAssignedCname({});
            setSelectedRows([]);
            setSelectAll(false);
            setInputValue('');
            
        }
        
    };
    const handleDipFeatureRadioChange = (e) => {
        setDipFeatureType(Number(e.target.value));
        
    };
    const handleFeatureRadioChange = (e) => {
        setFeatureType(Number(e.target.value));
        
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedRows.length === 0) {
            alert("Please select at least one row")
            // Show a validation error, no rows selected
            return;
        }

        // If there's an error and the input isn't empty, don't submit.
        // Empty input is allowed for removal.
        if(error && inputValue){
            alert(error);
            return;
        }   

        const updatedAssignedCname = { ...assignedCname };
        selectedRows.forEach((telephoneNumber) => {
            if (inputValue) {
                updatedAssignedCname[telephoneNumber] = inputValue;
            } else {
                delete updatedAssignedCname[telephoneNumber];
            }
        });

        const updatedtnNumberList = formData.tnNumberRouteList.map((obj) => {
            if (selectedRows.includes(obj.telephoneNumber)) {
                // Remove existing callerId first
                const { callerId, ...rest } = obj;
                
                // If there's a new value, add it back
                if (inputValue) {
                    return {
                        ...rest,
                        callerId: { callingName: inputValue },
                    };
                }
                // Otherwise, return the object without callerId
                return rest;
            }
            return obj;
        });    
        setFormData({ ...formData, tnNumberRouteList: updatedtnNumberList, assignedCname :updatedAssignedCname });
        setAssignedCname(updatedAssignedCname);
    };

    const handleEnableCas = (e) => {
        e.preventDefault();
        
        if (selectedRows.length === 0) {
            alert("Please select at least one row")
            // Show a validation error, no rows selected
            return;
        }
        const updatedAssignedCas = { ...assignedCas };
        selectedRows.forEach((telephoneNumber) => {
            updatedAssignedCas[telephoneNumber] = "enable";
        });
        // console.log(updatedAssignedCname);
        // console.log(formData.tnNumberRouteList);

        const updatedtnNumberList = formData.tnNumberRouteList.map((obj) => {
            const telephoneNumber = obj.telephoneNumber;
            const casValue = updatedAssignedCas[telephoneNumber];

            if (casValue) {
              return {
                ...obj,
                cia_value: casValue ,
              };
            } else {
              return obj;
            }
        });    
        setFormData({ ...formData, tnNumberRouteList: updatedtnNumberList, assignedCas :updatedAssignedCas });
        setAssignedCas(updatedAssignedCas);
    }

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            // Exclude Canadian numbers from CNAM selection
            const eligible = formData.reserveNumberList
                .filter(item => formData.methodType == 0 && !(showType === 1 && isCanadianNumber(item)))
                .map(item => item.telephoneNumber);
            setSelectedRows(eligible);
        }
        setSelectAll(!selectAll);
    };

    const handleToggleSelect = (phoneNumber, item) => {
        // Prevent selecting Canadian numbers for CNAM
        if (showType === 1 && item && isCanadianNumber(item)) return;

        const updatedSelectedRows = selectedRows.includes(phoneNumber)
        ? selectedRows.filter((num) => num !== phoneNumber)
        : [...selectedRows, phoneNumber];

        setSelectedRows(updatedSelectedRows);
    };

    const handleCnameChange = (e) => {
        const inputValue = e.target.value;
        setInputValue(inputValue);

        if (inputValue === '') {
            setError(''); // No error for empty string, as it means "remove"
            return;
        }

        // Regular expression to check if the input is valid
        const isValidInput = /^(?=(?:.*[A-Za-z]){1,})(?=(?:.*[A-Za-z0-9]){2,})[A-Za-z0-9 .,&_'-]{1,15}$/.test(inputValue);
        if (isValidInput) {
            setError('');
        } else {
            setError("Invalid input. Only alphabetical & numbers characters and spaces .,&_-' allowed, up to 15 characters.");
        }
    };

    return(
   
    <>
        <div className="row">
            <div className="col-6">
                <div className="left-title">
                    <h1>Order New Number </h1>
                    {/* <small>(Order Summary Step 3)</small> */}
                </div>
            </div>
            <div className="col-6">
            </div>
        </div>
        <div className="common-white-shadow-background setting-section tableinput-section">
            <div className="row footer-row">
                <div className="footer-row-left">
                    <a href="#" onClick={onBack} className="Back"> <img src="images/back-arrow.png" />Back</a>
                </div>
                <div className="footer-row-right">
                <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                    <a href="#" onClick={onNext} className="next">Next</a>
                </div>
            </div>
        </div>
        <div className="common-white-shadow-background setting-section">
            <div className="row">
                <div className="modification-txt">
                    <p>TELEPHONE NUMBER FEATURE ENTRY METHOD</p>
                </div>
                <div className="settingbox radio-standard-box">
                    <label for="skip"><input type="radio" id="skip" name="method_type" value={0} checked={formData.showType === 0} onChange={handleRadioChange} />
                        Skip</label>          
                    {formData.methodType === 0 && <label for="portal"><input type="radio" id="portal" name="method_type" value={1} checked={formData.showType === 1} onChange={handleRadioChange} />
                    CNAM</label>}
                    {ciaLabelDisplay && <label for="portal"><input type="radio" id="portal" name="method_type" value={2} checked={formData.showType === 2} onChange={handleRadioChange} />
                    E-NRMS</label>}                     
                </div>
                {showType === 1 && 
                    <>
                    <div className='col-sm-6' style={{ marginTop: '14px' }}>
                      <input
                        type="text"   
                        value={inputValue}                         
                        onChange={handleCnameChange}                   
                        placeholder="Enter CNAM"
                        // style={{ textTransform: 'uppercase' }}
                      />
                      {error && <p style={{ color: 'red' }}>{error}</p>}
                     
                    </div>
                   <div className='col-sm-6' style={{ marginTop: '11px' }}>
                         <input type="submit" className='yellow-button'  value="Apply"  onClick={handleSubmit} />
                    </div>
                    </>
                }
                {!ciaOrderSwitch && showType === 2 &&
                    <div className='apply-all' style={{ marginTop: '11px' }}>
                         {/* <input type="submit" className='apply-btn'  value="Apply"  onClick={handleSubmit} /> */}
                         <button className="apply-btn" onClick={handleEnableCas}>Apply</button>
                     </div>
                }
            </div>
        </div>
        <div className="common-white-shadow-background setting-section tableinput-section">
            <div className="row">
                <table className="tablebox new-number-two-setup">
                    <thead>
                        <tr>
                            {formData.methodType !== 2 && <th>Lata</th>}
                            {formData.methodType !== 2 && <th>Rate Center</th>}
                            {formData.methodType !== 2 && <th>State</th>}
                            <th>Tel Number</th>
                            {((showType === 1 || Object.keys(assignedCname).length > 0) || ((!ciaOrderSwitch &&showType === 2) || (!ciaOrderSwitch && Object.keys(assignedCas).length > 0))) &&<th style={{ paddingTop: "50px" }}> Select Number <input type="checkbox" className="newrow checkboxAll" onChange={handleSelectAll} checked={selectAll}  /></th>}
                            {(showType === 1 || Object.keys(assignedCname).length > 0) &&<th>Caller ID</th>}
                            {(showType === 2 || Object.keys(assignedCas).length > 0) &&<th>E-NRMS Type</th>}
                            <th>Routing Option</th>
                        </tr>
                    </thead>
                    <tbody>
                    {formData.reserveNumberList.map((item, index) => 
                         <tr key={index}>
                         {formData.methodType !== 2 && <td>{item.lata}</td>}
                         {formData.methodType !== 2 && <td>{item.rateCenterName}</td>}
                         {formData.methodType !== 2 && <td>{item.province}</td>}
                         <td>{item.telephoneNumber}</td>
                         {(((showType === 1|| Object.keys(assignedCname).length > 0) || ((!ciaOrderSwitch && showType === 2) || (!ciaOrderSwitch && Object.keys(assignedCas).length > 0))) && formData.methodType !== 1) && <td>{showType === 1 && isCanadianNumber(item) ? null : <input type="checkbox" name="" checked={selectedRows.includes(item.telephoneNumber)} onChange={() => handleToggleSelect(item.telephoneNumber, item)} />}</td>}
                   {showType === 1 && formData.methodType == 1 && <td></td>}
                   {(showType === 1 || Object.keys(assignedCname).length > 0) && <td><p className='green-text'>
      {showType === 1 && isCanadianNumber(item)
        ? 'N/A'
        : formData.tnNumberRouteList &&
          formData.tnNumberRouteList[index] &&
          formData.tnNumberRouteList[index].callerId &&
          formData.tnNumberRouteList[index].callerId.callingName
            ? formData.tnNumberRouteList[index].callerId.callingName
            : assignedCname[item.telephoneNumber] || ''}
    </p></td>}
                        {(showType === 2 || Object.keys(assignedCas).length > 0) && <td><p className='green-text'>
                            {formData.tnNumberRouteList &&
      formData.tnNumberRouteList[index] &&
      formData.tnNumberRouteList[index].cia_value ? formData.tnNumberRouteList[index].cia_value : assignedCas[item.telephoneNumber] || 'disabled'}</p></td>}
                         <td>
                         {/* <p className="green-text">{formData.tnNumberRouteList && formData.tnNumberRouteList[index]
                                ? formData.tnNumberRouteList[index].routeOption  || ''
                                :  ''}</p> */}
                                {formData.routeResults && formData.routeResults.length > 0 ? <p className='green-text'>{formData.routeResults[index]}</p> :  <p className="green-text">{formData.tnNumberRouteList && formData.tnNumberRouteList[index]
                                ?  (formData.tnNumberRouteList.find(items => items.telephoneNumber === item.telephoneNumber) || {}).routeOption
                                :  ''}</p>}
                               
                            </td>
                         {/* <td><p className="green-text">{item.routeOption}</p></td> */}
                     </tr>)}
                        
                    </tbody>
                </table>
            </div>
        </div>

        
      
    </>
)};

export default Step3;